import React from 'react';
import PropTypes from 'prop-types';

import { Stack, Typography, TextField, Box } from '@metarouter-private/mr-mui';

export default function ConfirmDeleteInput({ writeKey, onConfirmInputChange }) {
  const onInputChange = e => {
    onConfirmInputChange(e.target.value);
  };

  return (
    <Stack spacing={1}>
      <Typography variant="body2" color="text.secondary" data-test-id="confirmDeleteInstructions">
        To confirm deletion, enter the pipeline&apos;s write key:{' '}
        <Typography fontWeight="700" component="span" variant="body2" fontFamily="monospace">
          {writeKey}
        </Typography>
      </Typography>

      <Box width="50%">
        <TextField
          fullWidth
          variant="outlined"
          placeholder={writeKey}
          onChange={onInputChange}
          size="small"
          data-test-id="confirmDeleteInput"
        />
      </Box>
    </Stack>
  );
}

ConfirmDeleteInput.propTypes = {
  writeKey: PropTypes.string,
  onConfirmInputChange: PropTypes.func.isRequired,
};
